import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  getExp,
  getToken,
  getUser,
  signInExternal,
  signInSCG
} from '../Auth/authSCG';

export const verifyScgUserAsync = createAsyncThunk(
  'userProfile/verifyScgUser',
  signInSCG
);
export const getExternalUserAsync = createAsyncThunk(
  'userProfile/getExternalUser',
  signInExternal
);

export interface User {
  id: number;
  firstName: string;
  lastName: string;
}

export interface UserProfile {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  isActive: boolean;
  roles: string[];
  permissions: string[];
  isExternalUser: boolean;
}

export interface UserContextType {
  user: UserProfile | null;
  token: string | null;
  exp: number | null;
}

const initialState: UserContextType = {
  user: getUser(),
  token: getToken(),
  exp: getExp()
};

export default createSlice({
  name: 'userProfile',
  initialState,
  reducers: {
    clear: () => {
      return { user: null, token: null, exp: null };
    }
  },
  extraReducers: (builder) => {
    builder.addCase(verifyScgUserAsync.fulfilled, (state, action) => {
      return action.payload;
    });
    builder.addCase(getExternalUserAsync.fulfilled, (state, action) => {
      return action.payload;
    });
  }
});
